<template>
  <section class="section-outline">
      <div class="property-schedule">
        <template v-if="hasOpenHouses">
          <div class="f2 text-bold">Open houses</div>
          <div class="f5 text-gray">for {{dpp.geo.address}}.</div>
        </template>
        <template v-else>
          <div class="f2 text-bold">Tour this {{dpp.rdcMoveinReady === false ? 'community' : 'home'}}</div>
          <div class="f5 text-gray" v-if="dpp.rdcMoveinReady === false">When would you like to visit?</div>
          <div class="f5 text-gray" v-else>When would you like to see {{dpp.geo.address}}?</div>
        </template>
        <div class="property-openhouse-list" :class="{'open-houses': hasOpenHouses}">
          <template v-if="hasOpenHouses">
            <div class="open-houses-buttons">
              <button v-for="item in openHousesButtons" :key="item.timeText"  @click="openHotlead(item, {hotleadType: 'openHouseCalendarHotlead'})">
                  <i class="icon-calendar-hole"></i>
                  <span class="text-bold">{{ item.weekText }}</span>
                  <span class="text-bold">{{ item.dateText }}</span>
                  <span class="text-regular" v-if="item.timeText">{{ item.timeText }}</span>
              </button>
            </div>
          </template>
          <div>
            <p class="m-b-1" v-if="hasOpenHouses"><b class="text-bold">Select a date to see it sooner.</b></p>
            <mvtShifter class="date" type="2" :forceArrow="true">
              <button v-for="item in scheduleTourButtons" :key="item.timeText"  @click="openHotlead(item, {hotleadType: 'InlineDatePicker'})">
                 <span class="f6">{{ item.weekText }}</span>
                 <span class="text-bold f4">{{ item.dateText }}</span>
                 <span class="f6" v-if="item.timeText">{{ item.timeText }}</span>
              </button>
              <button v-if="scheduleTourButtons && scheduleTourButtons.length" @click="openHotlead(null, {hotleadType: 'InlineScheduleTour'})" type="button"> <span>Select <br> a date</span></button>
            </mvtShifter>
          </div>
        </div>
        <button class="btn primary medium" @click="openHotlead(null, {hotleadType: 'InlineScheduleTour'})" type="button">
          {{ dpp.rdcMoveinReady === false ? 'Schedule Community Tour' : molang('dpp.hotButton.scheduleTour') }}
        </button>
        <div class="property-schedule-question">
          <img loading="lazy" :src="glb.cdnUrl + 'vimages/icon-question-new.svg'"  alt="question"/>
          <div>
            <b> Have a question about this property? </b> Call us at <a href="tel:8444300869" class="link text-main text-bold">(844) 430-0869</a>
          </div>
        </div>
      </div>
   </section>
</template>
<script src="./property-schedule.js"></script>

<style lang="scss">
@use "./property-schedule.scss" as *;
</style>
